import * as amplitude from '@amplitude/analytics-browser';
// Only the ids that are set, so an event tracked before init() still gets the
// SDK's own ids once it starts.
export const getCurrentIdentity = () => {
    const userId = amplitude.getUserId();
    const deviceId = amplitude.getDeviceId();
    return {
        ...(userId && { user_id: userId }),
        ...(deviceId && { device_id: deviceId }),
    };
};
//# sourceMappingURL=current-identity.js.map